import Default from '../default/';

function _scale(keep) {
  const scale = this.scale();
  const munged = this.__execs__.munged;
  let regionDomain = Default.ordinalDomain(munged, 0, d => d.data.key, this.__execs__.field.region.order); 
  scale.color = this.updateColorScale(regionDomain, keep);
}

export default _scale;


// WEBPACK FOOTER //
// ./layouts/pie/_scale.js